import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const RESEND_INVITATION: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation resendInvitation($input: ResendInvitationInput!) {
    resendInvitation(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
